import FuncionService from 'src/modules/funcion/funcionService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'FUNCION_FORM';

const funcionFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: funcionFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await FuncionService.find(id);
      }

      dispatch({
        type: funcionFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: funcionFormActions.INIT_ERROR,
      });

      getHistory().push('/funcion');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: funcionFormActions.CREATE_STARTED,
      });

      await FuncionService.create(values);

      dispatch({
        type: funcionFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.funcion.create.success'),
      );

      getHistory().push('/funcion');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: funcionFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: funcionFormActions.UPDATE_STARTED,
      });

      await FuncionService.update(id, values);

      dispatch({
        type: funcionFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.funcion.update.success'),
      );

      getHistory().push('/funcion');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: funcionFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default funcionFormActions;
